import { createSelector } from 'reselect';
import { IndexedArray } from '@common/types';
import { ForwarderPointStatuses } from '@modules/settings/types';
import { MonitoringState } from '@modules/monitoring/types/store';

export const forwarderPointStatusesSelector = createSelector(
  (state: { Monitoring: MonitoringState }) => state.Monitoring.forwarderPointStatuses,
  (forwarderPointStatuses) => forwarderPointStatuses as IndexedArray<ForwarderPointStatuses>
);
